import { Injectable } from '@angular/core';
import { PluginListenerHandle } from '@capacitor/core';
import { Network } from '@capacitor/network';
import { BehaviorSubject, distinctUntilChanged, Observable, Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NetworkService {
    private _isConnectedSubject: BehaviorSubject<boolean | null> = new BehaviorSubject(null);
    private _connectionListener: PluginListenerHandle | undefined;
    private _networkSubscription: Subscription;

    constructor() {
        this._networkSubscription = this._isConnectedSubject.asObservable().pipe(
            distinctUntilChanged(),
        ).subscribe(isConnected => {
            if (isConnected !== null) {
                this.debug(isConnected);
            }
        });
    }

    private debug(status: boolean): void {
        console.debug(`[NETWORK] - connected: ${status}`);
    }

    async initialize(): Promise<void> {
        try {
            if (this._connectionListener) return;

            this._connectionListener = await Network.addListener("networkStatusChange", (connectionStatus) => {
                this._isConnectedSubject.next(connectionStatus.connected);
            });
            
            const connectionStatus = await Network.getStatus();
            this._isConnectedSubject.next(connectionStatus.connected);

        } catch(error) {
            console.error('[NETWORK] - initialize', error);
        }
    }

    getStatus(): boolean | null {
        return this._isConnectedSubject.value;
    }

    getStatusObservable(): Observable<boolean | null> {
        return this._isConnectedSubject.asObservable().pipe(
            distinctUntilChanged(),
        );
    }
}